export default __webpack_public_path__ + "static/media/turn-ideas-into-reality-1920w.9484a2d2.webp";